// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let DateFns = require("date-fns");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function classifyListingType(mlsListingType) {
  if (mlsListingType !== "ACTIVE" && mlsListingType !== "OFF_MLS" && mlsListingType !== "COMING_SOON") {
    return "unsupported";
  }
  switch (mlsListingType) {
    case "ACTIVE" :
    case "COMING_SOON" :
      return "activeOrComingSoon";
    case "OFF_MLS" :
      return "offMls";
  }
}

function classifyListingTypeInput(mlsListingType) {
  switch (mlsListingType) {
    case "ACTIVE" :
    case "COMING_SOON" :
      return "activeOrComingSoon";
    case "OFF_MLS" :
      return "offMls";
  }
}

function validateListingTypeRequired(mlsListingType) {
  if (mlsListingType !== undefined) {
    return "Valid";
  } else {
    return {
      NAME: "Error",
      VAL: "required"
    };
  }
}

function isTodayOrAfter(date, today) {
  if (DateFns.isSameDay(date, today)) {
    return true;
  } else {
    return DateFns.isAfter(date, today);
  }
}

function validateOnMlsAt(mlsListingType, onMlsAt, today, mustBeTodayOrAfter, classifyListingType) {
  if (mlsListingType === undefined) {
    return;
  }
  let match = classifyListingType(Primitive_option.valFromOption(mlsListingType));
  if (match === "unsupported") {
    return;
  } else if (match === "activeOrComingSoon") {
    if (onMlsAt !== undefined) {
      if (!mustBeTodayOrAfter || isTodayOrAfter(CalendarDate.toLocalDate(Primitive_option.valFromOption(onMlsAt)), today)) {
        return "Valid";
      } else {
        return {
          NAME: "Error",
          VAL: "mustBeTodayOrAfter"
        };
      }
    } else {
      return {
        NAME: "Error",
        VAL: "required"
      };
    }
  } else {
    return "Valid";
  }
}

exports.classifyListingType = classifyListingType;
exports.classifyListingTypeInput = classifyListingTypeInput;
exports.validateListingTypeRequired = validateListingTypeRequired;
exports.isTodayOrAfter = isTodayOrAfter;
exports.validateOnMlsAt = validateOnMlsAt;
/* date-fns Not a pure module */
